import React from 'react'
// import PhoneIcon from '../components/common/icons/Phone'
// import TelephoneIcon from '../components/common/icons/TelephoneIcon'
import MailIcon from '../components/common/icons/MailIcon'

interface ContactItemProps {
  icon: React.ReactNode
  text: string
}

const ContactItem: React.FC<ContactItemProps> = ({ icon, text }) => (
  <div className="flex items-center gap-2">
    <span>{icon}</span>
    <span className="text-white lg:font-bold lg:text-sm text-[12px] ">
      {text}
    </span>
  </div>
)

const BottomHeader: React.FC = () => {
  return (
    <div className="bg-darkBlue h-[3rem]">
      <div className="lg:w-11/12 mx-auto flex justify-between items-center h-full lg:px-0 px-2">
        <div className="flex lg:flex-row  items-center lg:gap-4 gap-2">
          {/* <ContactItem icon={<PhoneIcon />} text="+91 484 2550322" />
          <ContactItem icon={<TelephoneIcon />} text="2532890" /> */}
        </div>
        <div className="">
          <ContactItem icon={<MailIcon />} text="ceo.kied@gmail.com" />
        </div>
      </div>
    </div>
  )
}

export default BottomHeader
